<div *ngIf="item">
  <lhc-autocomplete 
    [options]="options" 
    [item]="item"
    [(dataModel)]="item.value"
    (onFocusFn)="lhcDataService.setActiveRow(item)"
    [isFormReady]="lhcDataService.isFormReady()"
  ></lhc-autocomplete>
</div>